import { render, staticRenderFns } from "./FinanceiroConfiguracoes.vue?vue&type=template&id=32095cbd&scoped=true&"
import script from "./FinanceiroConfiguracoes.vue?vue&type=script&lang=js&"
export * from "./FinanceiroConfiguracoes.vue?vue&type=script&lang=js&"
import style0 from "./FinanceiroConfiguracoes.vue?vue&type=style&index=0&id=32095cbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32095cbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VCombobox,VIcon,VRow,VTextField})
